// DEPRECATED
define('glu/store',[],function() {
    'use strict';

    function Storage(storageName) {
        storageName = storageName || 'sessionStorage';

        // storage emulation
        var defaultStore = {
            data: {},

            setItem: function(key, value) {
                var data = this.data;

                data[key] = value;

                return data[key];
            },

            getItem: function(key) {
                var data = this.data;

                return data[key];
            },

            removeItem: function(key) {
                var data = this.data,
                    value = data[key];

                if (!data.hasOwnProperty(key)) {
                    return;
                }

                delete data[key];

                return value;
            }
        };

        this.store = window[storageName] || defaultStore;

        return {
            store: this.store,

            getStorage: function(storeName) {
                return new Storage(storeName);
            },

            set: function(key, value) {
                var store = this.store;
                if (!store) {
                    return;
                }

                return store.setItem(key, JSON.stringify(value));
            },

            get: function(key) {
                var store = this.store;
                if (!store) {
                    return;
                }

                var value = store.getItem(key);

                return value ? JSON.parse(value) : null;
            },

            unset: function(key) {
                var store = this.store;
                if (!store) {
                    return;
                }

                return store.removeItem(key);
            }
        };
    }

    return new Storage();
});

